import SidebarMenuItem from "../types/sidebarMenuItem";
import locale from "./buildBackLinkItem.locale";
export default (hash) => new SidebarMenuItem("_back", locale.BACK, "icon-arrow-left text-primary-500 font-extra-bold", hash);
